export default {
    preferences: state => state.preferences,
    deviceRecentlySeen: state => state.deviceRecentlySeen,
    lastSeenItem: state => (state.deviceRecentlySeen && state.deviceRecentlySeen[0]) || null,
    getCards: state => state.cards,
    answersDailyLimit: state => state.answersDailyLimit,
    favorites: state => state.favorites,
    homeRecommendations: state => state.homeRecommendations,
    triggerFavoritesChange: state => state.triggerFavoritesChange,
    cardsProgress: state => state.cardsProgress,
    searchList: state => state.searchList,
}
